import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, openBlock, renderSlot } from "vue";
//#region src/v2/components/data-table/DataTableRow.vue
var _sfc_main = {};
var _hoisted_1 = { class: "group contents" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("tr", _hoisted_1, [renderSlot(_ctx.$slots, "default")]);
}
var DataTableRow_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { DataTableRow_default as default };

//# sourceMappingURL=DataTableRow.vue.js.map